import { supabase } from "./supabase";
import { Contact, CreateVendor, dbVendor, Vendor, VendorType } from "./types";
import { getGuid } from "./utils";

export const deleteContact = (id: string) => { };

export const getAllContacts = async () => {
  let { data, error } = await supabase.from("contacts").select("*");

  if (data) {
    const result = (data as Contact[]).sort((a, b) =>
      a.name.localeCompare(b.name)
    ) as Contact[];
    return result;
  } else {
    console.error(error?.message);
    throw error?.message;
  }
};

export const getAllVendorTypes = async () => {
  let { data, error } = await supabase.from("vendor_types").select("*");

  if (data) {
    const result = data.sort((a, b) => a.order - b.order) as VendorType[];
    return result;
  } else {
    console.error(error?.message);
    throw error?.message;
  }
};

export const getVendorsByContact = async (id: string) => {
  let { data, error } = await supabase
    .from("vendors")
    .select("*, type: vendor_types!inner(*), contact: contacts!inner(*)")
    .eq("contact", id);

  if (data) {
    return data?.map((v) => {
      if (v.mainVendor) {
        return {
          ...data?.find((_v) => _v.id === v.mainVendor),
          id: v.id,
          description: v.description,
          visible: v.visible,
          type: v.type,
          mainVendor: data?.find((d) => d.id === v.mainVendor),
        };
      } else {
        return v;
      }
    }) as Vendor[];
  } else {
    console.error(error?.message);
    throw error?.message;
  }
};

export const getAllVendors = async () => {
  let { data, error } = await supabase
    .from("vendors")
    .select("*, type: vendor_types!inner(*),  contact: contacts!inner(*)");

  if (data) {
    return data?.map((v) => {
      if (v.mainVendor) {
        return {
          ...data?.find((_v) => _v.id === v.mainVendor),
          id: v.id,
          description: v.description,
          visible: v.visible,
          type: v.type,
          mainVendor: data?.find((d) => d.id === v.mainVendor),
        };
      } else {
        return v;
      }
    }) as Vendor[];
  } else {
    console.error(error?.message);
    throw error?.message;
  }
};

export const updateContact = async (contact: Contact) => {
  const { data, error } = await supabase
    .from("contacts")
    .update(contact)
    .eq("id", contact.id)
    .select();

  if (data) {
    return data[0];
  } else {
    throw error?.message;
  }
};

export const updateVendor = async (vendor: dbVendor) => {
  const { data, error } = await supabase
    .from("vendors")
    .update({ ...vendor, contact: vendor.contact })
    .eq("id", vendor.id)
    .select();

  if (data) {
    return data[0];
  } else {
    throw error?.message;
  }
};

export const createContact = async (contact: Contact) => {
  const { data, error } = await supabase
    .from("contacts")
    .insert(contact)
    .select();

  if (data) {
    return data[0];
  } else {
    throw error?.message;
  }
};

export const createVendor = async (vendor: CreateVendor) => {
  const { data, error } = await supabase
    .from("vendors")
    .insert(vendor)
    .select();

  if (data) {
    return data[0];
  } else {
    throw error?.message;
  }
};

export const updateVendorValue = async (
  id: string,
  key: keyof Vendor,
  value: any
) => {
  const { data, error } = await supabase
    .from("vendors")
    .update({ [key]: value })
    .eq("id", id)
    .select();

  if (data) {
    return data[0];
  } else {
    throw error?.message;
  }
};

export const updateVendorType = async (vendor: VendorType) => {
  const { data, error } = await supabase
    .from("vendor_types")
    .upsert(vendor)
    .eq("id", vendor.id)
    .select();

  if (data) {
    return data[0];
  } else {
    throw error?.message;
  }
};

export const deleteVendor = async (id: string) => {
  const { error } = await supabase.from("vendors").delete().eq("id", id);

  if (error) {
    throw error?.message;
  }
};

export const uploadLogo = async (
  file: any,
  filename: string,
  directory: "vendors" | "types"
) => {
  const response = await supabase.storage
    .from("Kalyanam")
    .upload(`${directory}/${filename}`, file, {
      cacheControl: "3600",
    });

  if (response.data?.path) {
    const { data } = await supabase.storage
      .from("Kalyanam")
      .getPublicUrl(`${response.data?.path}`);
    return data.publicUrl;
  } else {
    throw new Error(response.error?.message || "Upload failed");
  }
};

export const handleVendorClick = async (vendorId: string) => {
  let clientId = localStorage.getItem("clientId");
  if (!clientId) {
    clientId = getGuid();
    localStorage.setItem("clientId", clientId);
  }

  try {
    await fetch(
      `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/track-click`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ vendorId, clientId }),
      }
    );
  } catch (err) {
    console.error(err);
  }
};


export const getVendorClicks = async (
  vendorId?: string,
  from?: string,
  to?: string
) => {
  let query = supabase
    .from("vendor_clicks")
    .select("*")
    .order("clickedAt", { ascending: false })
    .limit(10000);

  if (vendorId) query = query.eq("vendorId", vendorId);
  if (from) query = query.gte("clickedAt", from);
  if (to) query = query.lte("clickedAt", to);

  const { data, error } = await query;

  if (data) {
    return data as any[];
  } else {
    console.error(error?.message);
    throw error?.message;
  }
};